import React from 'react';

import {
  Button,
  Grid,
  // Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';

// import CssBaseline from '@material-ui/core/CssBaseline';
// import Topbar from '../components/Topbar';
// import Footer from '../components/Footer';
// import Container from '../components/Div/Container';
// import MainTitle from '../components/Text/MainTitle';
import SubTitle from '../components/Text/SubTitle';
// import { FaFileUpload } from 'react-icons/fa';

import { EVENT_IMG } from '../constatns';

const styles = (theme) => ({
  body: {
    fontSize: '1.2em',
    lineHeight: 1.8,
    '& span': {
      // color: 'red',
      fontWeight: 'bold',
    },
  },

  importantDatesDiv: {
    // borderRadius: 0,
    borderRadius: '5px',
    color: '#fff',
    // boxShadow: 'none',
    padding: theme.spacing(5, 6),
  },
  importantDatesDate: {
    fontWeight: 'bold',
    fontSize: '1.6em',
  },
  importantDatesTitle: {
    fontSize: '1.2em',
  },

  stepsDiv: {
    display: 'flex',
  },
  stepItem: {
    width: '20%',
  },
  stepsNo: {
    fontSize: '1.2em',
    color: '#7d889a',
    '& span': {
      fontSize: '1.2em',
      fontWeight: 'bold',
    },
  },
  stepContent: {
    padding: theme.spacing(3, 4),
    color: '#fff',
    // height: '100%',
  },

  topicTitle: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: '1.2em',
    marginBottom: '0.5em',
  },
  topicContents: {
    '& p': {
      paddingLeft: 8,
      textIndent: -8,
    },
  },

  orderedList: {
    '& li': { marginBottom: '0.6rem', fontWeight: 500, fontSize: '1.2em', lineHeight: 1.6, color: '#000000' },
    '& span': {
      color: 'red',
      fontWeight: 'bold',
    },
  },

  unorderedList: {
    '& > p': { fontWeight: 500, paddingInlineStart: '20px', fontSize: '1.2em', lineHeight: 1.6 },
    '& span': {
      color: 'red',
      fontWeight: 'bold',
    },
  },
  btnIcon: {
    color: '#fff',
  },
});

const StyledTableRow = withStyles((theme) => ({
  root: {
    color: '#000000',
    '& th': { textAlign: 'center', fontWeight: 'bold' },
    '& td': {
      fontWeight: 500,
      '& p': {
        textIndent: '-0.65em',
        paddingLeft: '0.6em',
      },
    },
    '&:nth-of-type(odd)': {
      '& th': {
        backgroundColor: '#cfdae6',
      },
      '& td': {
        backgroundColor: '#e6edf6',
      },
    },
    '&:nth-of-type(even)': {
      '& th': {
        backgroundColor: '#e9eff5',
      },
      '& td': {
        backgroundColor: '#f4f7fa',
      },
    },
  },
}))(TableRow);

class FreePaperGuideKr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };

    this.stepNoRef = React.createRef();
    this.stepContentRef = React.createRef();
  }

  componentDidMount() {
    for (let i = 1; i <= 5; i++) {
      document.getElementById(`steps-content-${i}`).style.height = `${document.getElementById(`steps-content-1`).scrollHeight}px`;
    }
  }

  stepsForSubmission() {
    const { classes } = this.props;
    const STEPS = [
      {
        no: 1,
        color: '#7d889a',
        bgColor: 'rgba(125,136,154, 0.1)',
        title: 'Sign-up or Log in',
        content: 'PRS KOREA 홈페이지에 회원 가입이 되어 있는 경우 로그인 하신 후, 초록 제출을 하실 수 있습니다.',
      },
      {
        no: 2,
        color: '#265c7a',
        bgColor: 'rgba(38, 92, 122, 0.1)',
        title: 'Submit your abstract',
        content: '저자와 초록정보를 입력하신 후 “Save”버튼을 클릭하셔야 접수가 최종적으로 완료 됩니다.',
      },
      {
        no: 3,
        color: '#0c7282',
        bgColor: 'rgba(12,114,130, 0.1)',
        title: 'Confirmation Letter',
        content: '초록제출 후, 초록제출확인 메일이 발송 됩니다.',
      },
      {
        no: 4,
        color: '#7fb46d',
        bgColor: 'rgba(127,180,109, 0.1)',
        title: 'My Page',
        content:
          '제출한 초록 수정은 초록제출 마감일 전까지 "MY PAGE"에서 수정을 하실 수 있습니다.<br/>(마감일 이후에는 수정이 불가합니다.)',
      },
      {
        no: 5,
        color: '#d0d24d',
        bgColor: 'rgba(208,210,77, 0.1)',
        title: 'Acceptance Notification',
        content: '초록채택결과는 메일로 발송됩니다.',
      },
    ];

    return (
      <div className={classes.stepsDiv}>
        {STEPS.map((step, idx) => (
          <div key={`step-for-submission-${idx}`} className={classes.stepItem}>
            <div
              className={classes.stepsNo}
              style={{
                backgroundColor: step.bgColor,
                position: 'relative',
                padding: this.props.theme.spacing(2, 0),
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-around',
              }}
              id={`steps-no-${idx + 1}`}
            >
              <p style={{ backgroundColor: step.color, width: '1em', height: '0.3em', position: 'absolute', bottom: '20%', left: 0 }} />
              <div>
                Step <span style={{ color: step.color }}>0{idx + 1}</span>
              </div>
              <img src={`${EVENT_IMG}/submission_step_${step.no}.png`} style={{ height: '2.5em' }} alt="" />
            </div>
            <div className={classes.stepContent} style={{ backgroundColor: step.color }} id={`steps-content-${idx + 1}`}>
              <Typography style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{step.title}</Typography>
              <div style={{ marginTop: '0.5em', paddingBottom: '3em' }}>
                <span style={{ fontSize: '1.1em', lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: step.content }} />
              </div>
              {/* <Typography style={{ fontSize: '1em', marginTop: '0.5em', paddingBottom: '1em'}}>{step.content}</Typography> */}
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <React.Fragment>
        <div>
          {/* <h3>Will be Updated</h3> */}
          <Grid container direction="row" alignItems="center">
            <SubTitle>Abstract Submission</SubTitle>
          </Grid>
          <Typography className={classes.body}>
            <span style={{ color: 'red', fontWeight: 'bold' }}>초록접수 마감일인 8월 26일 (금) 까지</span>&nbsp; 학술대회
            홈페이지(https://www.prskorea.org/)를 통하여 초록을 제출하시기 바랍니다.
            <br />
            제출된 초록은 초록접수기간동안 웹사이트에서 수정하실 수 있으며, 제출된 초록은 학술위원회에서 심사합니다.
            <br />
            채택된 초록은 Oral 또는 E-Poster로 발표하게 되며, 초록집에 게재됩니다.
            <br />
            <span style={{ color: this.props.theme.palette.primary.main }}>초록제출 전 아래 가이드라인을 확인하여 주시기 바랍니다.</span>
          </Typography>
          <div style={{ textAlign: 'center', marginTop: '1em' }}>
            <Button
              variant="contained"
              // color="primary"
              // disableElevation
              onClick={() => this.props.moveToSubmission()}
              style={{
                borderRadius: '5px',
                backgroundColor: '#164273',
                color: '#fff',
                fontSize: '1.4em',
                fontWeight: 700,
                padding: '1em 0',
                textTransform: 'none',
                width: '300px',
              }}
              // startIcon={<FaFileUpload size={30} />}
            >
              초록 접수 바로가기
            </Button>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Important Dates</SubTitle>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#7d889a' }}>
                <Typography className={classes.importantDatesTitle}>초록접수마감일</Typography>
                <Typography className={classes.importantDatesDate}>2022년 8월 26일 (금)</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#265c7a' }}>
                <Typography className={classes.importantDatesTitle}>초록채택안내</Typography>
                <Typography className={classes.importantDatesDate}>2022년 9월 8일 (목)</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#164273' }}>
                <Typography className={classes.importantDatesTitle}>발표자 사전등록 마감일</Typography>
                <Typography className={classes.importantDatesDate}>2022년 10월 31일 (월)</Typography>
              </div>
            </Grid>
          </Grid>
        </div>

        <div>
          <div style={{ height: '50px' }} />
        </div>

        <div>
          <SubTitle>Steps for Submission</SubTitle>
          {this.stepsForSubmission()}
        </div>

        <div>
          <div style={{ height: '50px' }} />
        </div>

        <div>
          <SubTitle>Abstract Topic</SubTitle>
          <Grid container spacing={1}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: '#265c7a',
                        color: '#fff',
                        fontSize: '1.2em',
                        borderRight: '1px solid #fff',
                        fontWeight: 'bold',
                      }}
                    >
                      Reconstruction
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#869e53',
                        color: '#fff',
                        fontSize: '1.2em',
                        fontWeight: 'bold',
                        borderleft: '1px solid #fff',
                      }}
                    >
                      Aesthetic
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: '#e9eef1',
                        color: '#000000',
                        // fontWeight: 'bold',
                        fontSize: '1.2em',
                        lineHeight: 1.6,
                        borderRight: '1px solid #fff',
                      }}
                    >
                      <p>- 기초연구 (Basic Research)</p>
                      <p>- 소아 및 두개안면 (Pediatric / Craniofacial)</p>
                      <p>- 수부 및 상지 재건 (Hand & Upper Limb Reconstruction)</p>
                      <p>- 두경부 재건 (Head and Neck Reconstruction)</p>
                      <p>- 유방 체부 재건 (Breast / Body Reconstruction)</p>
                      <p>- 하지재건 (Lower Limb Reconstruction)</p>
                      <p>- 림프부종(Lymphedema)</p>
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#e9eef1',
                        color: '#000000',
                        // fontWeight: 'bold',
                        fontSize: '1.2em',
                        lineHeight: 1.6,
                        borderleft: '1px solid #fff',
                      }}
                    >
                      <p>- 눈성형 (Eyelid and Periocular Surgery)</p>
                      <p>- 코성형 (Rhinoplasty)</p>
                      <p>- 항노화수술 (Anti-aging Surgery)</p>
                      <p>- 안면윤곽수술 (Facial Contouring Surgery)</p>
                      <p>- 유방성형 (Aesthetic Breast Surgery)</p>
                      <p>- 체형교정수술 (Body Contouring Surgery)</p>
                      <p>- 보톡스, 필러, 최소침습 (Botox, Filler, Minimally Invasive Surgery)</p>
                      <p>- 레이저 (Laser)</p>
                      <p>- 지방성형, 줄기세포 (Fat and Stem cell Therapy)</p>
                      <p>- 모발 (Hair)</p>
                      <p>- 기타성형 (Other Plastic Surgery)</p>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {/* <Grid item xs={4}>
              <Typography className={classes.topicTitle}>Reconstruction</Typography>
              <div className={classes.topicContents}>
                <p>- 기초연구 (Basic Research)</p>
                <p>- 소아 및 두개안면 (Pediatric / Craniofacial)</p>
                <p>- 수부 및 상지 재건 (Hand & Upper Limb Reconstruction)</p>
                <p>- 두경부 재건 (Head and Neck Reconstruction)</p>
                <p>- 유방 체부 재건 (Breast / Body Reconstruction)</p>
                <p>- 하지재건 (Lower Limb Reconstruction)</p>
                <p>- 림프부종(Lymphedema)</p>
              </div>
            </Grid>
            <Grid item xs={8}>
              <Typography className={classes.topicTitle}>Aesthetic</Typography>
              <div className={classes.topicContents} style={{ columnCount: 2, WebkitColumnCount: 2, MozColumnCount: 2 }}>
                <p>- 눈성형 (Eyelid and Periocular Surgery)</p>
                <p>- 코성형 (Rhinoplasty)</p>
                <p>- 항노화수술 (Anti-aging Surgery)</p>
                <p>- 안면윤곽수술 (Facial Contouring Surgery)</p>
                <p>- 유방성형 (Aesthetic Breast Surgery)</p>
                <p>- 체형교정수술 (Body Contouring Surgery)</p>
                <p>- 보톡스, 필러, 최소침습 (Botox, Filler, Minimally Invasive Surgery)</p>
                <p>- 레이저 (Laser)</p>
                <p>- 지방성형, 줄기세포 (Fat and Stem cell Therapy)</p>
                <p>- 모발 (Hair)</p>
                <p>- 기타성형 (Other Plastic Surgery)</p>
              </div>
            </Grid> */}
          </Grid>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Submission Guidelines</SubTitle>
          <div style={{ backgroundColor: '#f6f6f6', display: 'flex', padding: theme.spacing(3, 4) }}>
            <div
              style={{
                color: '#5d6573',
                fontWeight: 'bold',
                fontSize: '1.5em',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingRight: theme.spacing(3),
                borderRight: '1px solid #7d889a',
              }}
            >
              Abstract Format
            </div>
            <div style={{ color: '#000000', fontSize: '1.1em', lineHeight: 1.6, fontWeight: 'bold', paddingLeft: theme.spacing(3) }}>
              - Title : 최대 <b style={{ color: 'red' }}>30단어</b>
              <br />- Body : 최대 <b style={{ color: 'red' }}>250</b>단어
              <br />- 그림이나 테이블(jpg, gif 형식파일)은 <b style={{ color: 'red' }}>4개</b> 까지 등록 가능
              <br />
            </div>
          </div>
          <div style={{ color: '#000000' }}>
            <ol className={classes.orderedList}>
              <li>초록은 PRS KOREA 2022 홈페이지를 통하여 접수가 가능하며, 이메일, 팩스 또는 우편을 통한 접수는 인정되지 않습니다.</li>
              <li>
                초록은 반드시 <span style={{ textDecoration: 'underline' }}>"영어"</span>로 작성해야하며, <span>2022년 8월 26일 (금)</span>
                까지 Oral 또는 E-Poster를 선택하여 제출해야 합니다.
              </li>
              <li>초록접수 시, 텍스트의 오탈자나 문법 오류가 없도록 하는 것은 저자(author)의 책임입니다.</li>
              <li>제목은 간결해야하며, 추상적인 내용을 반영해야 합니다.</li>
              <li>초록본문은 반드시 4가지 항목 "Purpose, Methods, Results, Conclusion" 으로 작성해 주십시오.</li>
              <li>
                초록본문에 사용할 수 있는 최대 단어수는 <span style={{ textDecoration: 'underline' }}>250 단어</span>입니다.
              </li>
              <li>제출한 초록은 “My Page”에서 초록접수마감일(자정 전)까지 수정하실 수 있습니다.</li>
              <li>
                초록제출 후, 초록 접수 완료 메일이 저자와 교신저자(접수할 때 기재하신 이메일로 발송)에게 발송되오니 올바른 정보를 입력하여
                주시기 바랍니다.
                <br />
                잘못된 정보를 입력할 경우, 초록 접수 완료 메일 및 초록 채택 메일을 받지 못할 수 있습니다.
                <br />
                완료메일을 못 받으신 회원은 PRS KOREA 2022 Academic 사무국 (
                <strong>
                  <a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a>
                </strong>
                )로 연락주시기 바랍니다.
              </li>
              <li>
                초록이 채택된 회원은 학술대회에 사전등록 하셔야 발표가 가능 하오니, <span>2022년 10월 31일 (월)</span>까지 등록 하여 주시기
                바랍니다.
              </li>
              <li>
                온라인으로 초록접수를 하실 수 없는 경우, PRS KOREA 2022 Academic 사무국 (
                <strong>
                  <a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a>
                </strong>
                )로 연락주시기 바랍니다.
              </li>
            </ol>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Structure</SubTitle>
          <div style={{ color: '#000000' }} className={classes.unorderedList}>
            {/* <p style={{ marginBottom: 8 }}>- 초록작성 시 아래 구성요소를 확인하여 작성하여 주시기 바랍니다.</p> */}

            <ul className={classes.orderedList}>
              <li>초록작성 시 아래 구성요소를 확인하여 작성해 주시기 바랍니다.</li>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: '#265c7a',
                        color: '#fff',
                        // color: theme.palette.common.white,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        border: '2px solid #fff',
                        fontSize: '1.2em',
                      }}
                    >
                      Purpose
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', border: '2px solid #fff', fontSize: '1.2em' }}>
                      가설 또는 연구 질문에 대한 진술
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em' }}
                    >
                      Methods
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', border: '2px solid #fff', fontSize: '1.2em' }}>
                      사용된 연구 설계 및 실험 방법에 대한 설명
                    </TableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em' }}
                    >
                      Results
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', border: '2px solid #fff', fontSize: '1.2em' }}>
                      실험 또는 연구의 주요 결과를 간략하게 요약
                      {/* <br />
                    심사위원의 심사와 대중에 의한 추론의 열람이 가능하도록 충분한 데이터를 제공해야 하며, “데이터 추후 논의"과 같은 문장은
                    인정되지 않음. */}
                    </TableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em' }}
                    >
                      Conclusion
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', border: '2px solid #fff', fontSize: '1.2em' }}>
                      전체 결과 및 연구의 중요성에 대한 요약
                    </TableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <TableCell
                      component={'th'}
                      style={{ backgroundColor: '#265c7a', color: '#fff', border: '2px solid #fff', fontSize: '1.2em' }}
                    >
                      Remarks*
                      <br />
                      <span style={{ fontSize: '1.0em', color: 'yellow' }}>
                        (Abstract
                        <br />
                        Qualifications)
                      </span>
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#e9eef1', border: '2px solid #fff' }}>
                      <div style={{ fontSize: '1.2em', lineHeight: 1.7 }}>
                        <p>* 주제는 새로운 내용이어야 합니다.</p>
                        <p>* 현재 진행 중인 연구의 자료는 발표해서는 안된다.</p>
                        <p>* 최종 data가 초록에 포함되어야 한다.</p>
                        <p>* 장기간 추적 관찰한 증례에 우선권을 부여한다.</p>
                        <p>
                          * 신원을 식별할 수 있는 사진 자료를 사용하는 경우, 환자동의서를 받아 보관하여야 한다.
                          <br />
                          (환자에게 동의서를 받는 것은 저자의 책임이다.)
                        </p>
                        <p>* 모든 사진 자료는 컴퓨터 프로그램 등으로 교정, 수정해서는 안된다.</p>
                        <p>* 성형외과학의 발전에 기여하고 회원들의 학술적 발전에 도움이 될 수 있는 내용을 포함하여야 한다.</p>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </ul>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Notification of Acceptance</SubTitle>
          <div style={{ color: '#000000' }} className={classes.unorderedList}>
            <p>
              - 제출된 초록은 학술위원회의 심의를 거쳐 <span>2022년 9월 8일 (목)</span>에 발표자 및 교신저자 이메일 주소로 초록채택메일을
              발송하여 채택여부를 안내해 드립니다.
            </p>
          </div>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Withdrawal of Abstracts</SubTitle>
          <div style={{ color: '#000000' }} className={classes.unorderedList}>
            <p>
              - 초록채택 된 회원은 <span style={{ textDecoration: 'underline' }}>사전등록마감일까지</span> 등록하여야 발표가 가능하며, 기간
              내 등록하지 않을 경우 초록 채택이 철회 될 수 있습니다.
            </p>
            <p>
              - 초록 철회를 원하시는 회원은 PRS KOREA 2022 Academic 사무국 (
              <a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a>
              )로 메일 주시기 바랍니다.
            </p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FreePaperGuideKr);
